import React, { useEffect } from "react";
import { Col, Row, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import imageLists from "../../assets/images/partner/list.json";
import { compareSort } from "../../helpers";

interface IProps {
  // title: string;
  // folder: string;
  filter: string[];
  searchQuery: string;
  onSearchResult: (hasData: boolean) => void;
  onImageCount: (count: number) => void;
}

interface Images {
  src: any;
  products: any;
  colors: any;
  imageName: any;
  name: any;
}

const FOLDERS = ["hotel", "food_beverages", "healthcare", "others"];

function getImages(filter: string[], searchQuery = "", folder: string) {
  return (
    Object.entries(imageLists)
      .filter(
        ([folderName, content]) => content !== null && folderName === folder
      )
      .map(([_, content]) => {
        return Object.values(content)
          .map((entry: any) => {
            const productsArray = Array.isArray(entry.products)
              ? entry.products
              : [entry.products];

            const productColors = productsArray.map((product: string) => {
              if (product === "po-financing") return "#4A4A49";
              if (product === "employee-loan") return "#009344";
              if (product === "invoice-financing") return "#05A0C0";
              return "#7A288A";
            });

            return {
              src: require(
                `../../assets/images/partner/${folder}/${entry.file}`
              ),
              products: productsArray,
              colors: productColors,
              imageName: entry.image_name.toLowerCase(),
              name: entry.image_name,
            };
          })
          .filter((image) => {
            let filterProduct = true;
            let filterName = true;
            if (filter.length > 0) {
              filterProduct = image.products.some((product: string) =>
                filter.includes(product)
              );
            }
            if (searchQuery !== "") {
              filterName = image.imageName.includes(searchQuery.toLowerCase());
            }
            return filterProduct && filterName;
          });
      })[0] || []
  );
}
function PartnerList({
  filter,
  searchQuery,
  onSearchResult,
  onImageCount,
}: IProps) {
  let images: Images[] = [];
  for (let folder of FOLDERS) {
    const newImages = getImages(filter, searchQuery, folder);
    images = [...images, ...newImages];
  }
  images.sort((a, b) =>
    compareSort(a.imageName.toLowerCase(), b.imageName.toLowerCase(), "asc")
  );

  useEffect(() => {
    onSearchResult(images.length > 0);
  }, [images.length, onSearchResult]);

  useEffect(() => {
    onImageCount(images.length);
  }, [images.length, onImageCount]);
  return (
    <React.Fragment>
      {images.length > 0 && (
        <div className="">
          {/* <div className="fw-extra-bold text-size-sub-headline">{title}</div> */}
          <Row className="align-items-center text-center">
            {images.map((a, idx) => (
              <Col
                xl={2}
                lg={3}
                md={4}
                sm={6}
                xs={6}
                className="mt-4 mb-2 d-flex justify-content-center"
                key={`partner-${idx}`}
              >
                <div className="partner-card">
                  <div className="categoryProducts">
                    {a.colors.map((color: string, index: number) => (
                      <span
                        key={`circle-${idx}-${index}`}
                        style={{
                          right: 5 + index * 15,
                          backgroundColor: color,
                        }}
                      ></span>
                    ))}
                  </div>

                  <OverlayTrigger
                    overlay={<Tooltip id={a.imageName}>{a.name}</Tooltip>}
                  >
                    <Image src={a.src} fluid className="mt-2" alt={a.imageName} />
                  </OverlayTrigger>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </React.Fragment>
  );
}

export default PartnerList;
